import React, { useEffect, useState } from 'react';
import './CameraView.css';

const CameraView = ({ deviceId, cameraIp }) => {
  console.log('Camera ip:', cameraIp);
  const [peopleCount, setPeopleCount] = useState(0);
  const [objectCount, setObjectCount] = useState(0);
  const [status, setStatus] = useState('Normal');
  const [connected, setConnected] = useState(false);
  const [error, setError] = useState(null);
  
  // Set default camera IP if none provided
  const cameraUrl = cameraIp || 'https://192.168.4.10:8889/cam/';
  
  useEffect(() => {
    let socket = null;
    
    const connectWebSocket = () => {
      try {
        // WebSocket server URL - replace with your actual ML server WebSocket URL
        socket = new WebSocket('ws://192.168.0.1:3000');
        
        socket.onopen = () => {
          console.log('Connected to camera analytics server');
          setConnected(true);
          setError(null);
          
          // Send device ID to identify this connection
          if (deviceId) {
            socket.send(JSON.stringify({ type: 'register', deviceId: deviceId }));
          }
        };
        
        socket.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);
            
            // Update state based on received data
            if (data.peopleCount !== undefined) setPeopleCount(data.peopleCount);
            if (data.objectCount !== undefined) setObjectCount(data.objectCount);
            if (data.status !== undefined) setStatus(data.status);
          } catch (err) {
            console.error('Error parsing WebSocket message:', err);
          }
        };
        
        socket.onerror = (error) => {
          console.error('WebSocket error:', error);
          setError('Connection error');
          setConnected(false);
        };
        
        socket.onclose = (event) => {
          console.log('WebSocket connection closed:', event.code, event.reason);
          setConnected(false);
          
          // Attempt to reconnect after 5 seconds
          setTimeout(connectWebSocket, 5000);
        };
      } catch (err) {
        console.error('Failed to establish WebSocket connection:', err);
        setError('Failed to connect');
        setConnected(false);
        
        // Attempt to reconnect after 5 seconds
        setTimeout(connectWebSocket, 5000);
      }
    };
    
    // Initial connection
    connectWebSocket();
    
    // Cleanup on unmount
    return () => {
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.close();
      }
    };
  }, [deviceId]);
  
  return (
    <div className="camera-view-container">
      <div className="camera-status-bar">
        <div className={`connection-indicator ${connected ? 'connected' : 'disconnected'}`}>
          {connected ? 'Connected' : 'Disconnected'}
        </div>
        <div className="status-metrics">
          <span>People: {peopleCount}</span>
          <span>Objects: {objectCount}</span>
          <span>Status: {status}</span>
        </div>
      </div>
      
      <div className="camera-frame">
        <iframe 
          src={cameraUrl} 
          title="Camera Feed" 
          frameBorder="0" 
          allowFullScreen
        ></iframe>
        
        {error && (
          <div className="camera-error-overlay">
            <div className="error-message">{error}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CameraView;
